var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-81v-798l60 59.85L240-879l60 59.85L360-879l60 59.85L480-879l60 59.85L600-879l60 59.85L720-879l60 59.85L840-879v798l-60-59.85L720-81l-60-59.85L600-81l-60-59.85L480-81l-60-59.85L360-81l-60-59.85L240-81l-60-59.85L120-81Zm117-215h490v-60H237v60Zm0-154h490v-60H237v60Zm0-155h490v-60H237v60Zm-57 423h600v-596H180v596Zm0-596v596-596Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.83e21f9fa8275ff67e8666961e57433c.svg";
export { ForwardRef as ReactComponent };